module.exports = __webpack_public_path__ + "static/media/penneli-1.b34ccb37.png";